export default "/_next/static/chunks/fonts/WhitneySSm-SemiboldItalic-Pro_Web-20eb8bd973b9c0a0e353e6fc897001a8.woff2";